import React, { memo } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SideBar from "./SideBar";

const Layout = ({
  children,
  headerVariant,
  headerColor,
  className,
  hidefooter = false,
  showSidebar,
  bgcolor,
  dashboardFooter,
}) => {
  return (
    <>
      <Header variant={headerVariant} color={headerColor} bgcolor={bgcolor} />

      {showSidebar ? (
        <main className="d-flex">
          <SideBar />
          <div className={`w-100 ${className || ""}`}>{children}</div>
        </main>
      ) : (
        <main className={className}>{children}</main>
      )}

      {!hidefooter && (
        <Footer dashboardFooter={dashboardFooter} bgcolor={bgcolor} />
      )}
    </>
  );
};

export default memo(Layout);
